import { useMutation } from "@tanstack/react-query";
import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";

export const updateSportsbookEntityName = async ({
  entityType,
  sportId,
  displayName,
  translationKey,
  translations,
}) => {
  if (!entityType || !sportId || !displayName) return null;

  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken,
  );

  const payload = {
    entity_type: entityType,
    sport_id: sportId,
    display_name: displayName,
  };
  if (
    translationKey &&
    translations &&
    typeof translations === "object" &&
    !Array.isArray(translations) &&
    Object.keys(translations).length > 0
  ) {
    payload.translation_key = translationKey;
    payload.translations = translations;
  }

  const response = await PrivateAdminPanelInstance.patch(
    API_ROUTES.UPDATE_SPORTSBOOK_SPORT_NAME,
    payload,
  );

  return response?.data ?? null;
};

export const useUpdateSportsbookEntityName = () =>
  useMutation({
    mutationKey: ["sportsbookFm", "entity", "updateName"],
    mutationFn: updateSportsbookEntityName,
  });
